export default "__VITE_ASSET__6PQ1hOl$__"